import { render, staticRenderFns } from "./ActivityAssignment.vue?vue&type=template&id=c8b191d8"
import script from "./ActivityAssignment.vue?vue&type=script&lang=js"
export * from "./ActivityAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports